import { useState } from 'react'
import styles from './UserMoneyAcc.module.css'
import cover from '../../../assets/user-acc.png'
import coin from '../../../assets/white_coin.svg'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { useSelector } from 'react-redux'
import { hideAccNumber } from '../../../hooks/hideAccNumber'
import { formatSum } from '../../../utils/formatSum'

export default function UserMoneyAcc() {
	const [visible, setVisible] = useState(false)
	const { personal_acc_number, personal_acc_balance } = useSelector((state) => state.user)
	const hideNumber = personal_acc_number ? hideAccNumber(personal_acc_number) : ''

	return (
		<div className={styles.container}>
			<div className={styles.data}>
				<p className={styles.balance}>Баланс</p>
				<div className={styles.coin}>
					<p className={styles.amount}>{formatSum(personal_acc_balance)}</p>
					<img src={coin} alt='coin' />
				</div>

				<div className={styles.acc_number}>
					<p>Счет {visible ? formatSum(personal_acc_number) : hideNumber}</p>
					{visible ? (
						<VisibilityIcon
							sx={{ fontSize: 30, cursor: 'pointer' }}
							onClick={() => setVisible(false)}
						/>
					) : (
						<VisibilityOffIcon
							sx={{ fontSize: 30, cursor: 'pointer' }}
							onClick={() => setVisible(true)}
						/>
					)}
				</div>
			</div>

			<img src={cover} alt='User money account cover' className={styles.card_cover} />
		</div>
	)
}
